import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { ENTER } from '@angular/cdk/keycodes';
import { debounceTime } from 'rxjs/operators';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';

@Component({
  selector: 'app-add-ucmg',
  standalone: false,
  templateUrl: './add-ucmg.component.html',
  styleUrl: './add-ucmg.component.css'
})
export class AddUcmgComponent {
  _filterSegment: any;
  fundingSegmentSearch: string = '';
  numberFormatters = {};
  get filterSegment(): any {
    return this._filterSegment;
  }
  @Input() set filterSegment(value: any) {
    this._filterSegment = value;
  }
  @Input() capitalDemandRecords:any;
  @Output() dataRefresh: EventEmitter<any> = new EventEmitter();
  @Output() closeAndReset: EventEmitter<any> = new EventEmitter();
    private fundingSegmentSubscription: Subscription;

  segmentIdDropdown: any;
  lobLoader: boolean = false;
  fundingSegment: any;
  fundingSegmentList:any = [];
  disableApply: boolean = true;
  allowNegative: boolean = false;
  @ViewChild('inputAddPortfolioManager') inputAddPortfolioManager: any;
  @ViewChild('inputAddUCMGOwner') inputAddUCMGOwner: any;
  
  addUcmgDataUpdated = {
    "Funding_SegmentID": null,
    "UCMG_ID": '',
    "UCMG_Name": '',
    "acap": 0,
    "optumTechLabour": 0,
    "advisoryService": 0,
    "bussinessLabour": 0,
    "hardware_software": 0,
    "other_chargebacks": 0,
    "professional_fees": 0,
    "year":null,
    "investmentStatus":null
  };
  @Input() yearList = [];
  @Input() investmentStatus = [];
  numberFieldsToCheck: any[] = [];
  otherFieldsToCheck: any[] = [];
  constructor(public maintenanceService: MaintenanceService, private toaster: ToastrService, private capabilityService: CommonModelService,) {
  }

  ngOnInit(){
    this.loadFundingSegment();
    this.numberFieldsToCheck = [
     'advisoryService',
      'bussinessLabour',
      'hardware_software',
      'optumTechLabour',
      'other_chargebacks',
      'professional_fees'
    ];
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  // ValidateInput checks if the specified field is negative when acap is non-negative.
  // Returns true if error condition is met, false otherwise.
  ValidateInput(fieldToValidate: string): boolean {
    if (!fieldToValidate || !this.addUcmgDataUpdated) return false;
    const acapRaw = this.addUcmgDataUpdated.acap;
    const fieldRaw = this.addUcmgDataUpdated[fieldToValidate];
    if (acapRaw === null || acapRaw === undefined || fieldRaw === null || fieldRaw === undefined) return false;
    let acap = this.normalizeValue(this.convertCommaSeparatedToNormal(acapRaw));
    let fieldValue = this.normalizeValue(this.convertCommaSeparatedToNormal(fieldRaw));
    if (typeof acap !== 'number' || typeof fieldValue !== 'number') return false;
    return acap >= 0 && fieldValue < 0;
  }

  // normalizeValue safely converts input to a number, returning 0 for invalid cases.
  normalizeValue = (value: any) => {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'string' && value.trim() === '') return 0;
    let num = Number(value);
    if (isNaN(num)) return 0;
    return num;
  }
  ngOnChanges() {
    this.fundingSegmentSearch = ''
    this.fundingSegment = this.fundingSegmentList.map(segment=>segment.Funding_Segment);
    if (this.filterSegment) {
      this.segmentIdDropdown = this.filterSegment.map((seg) => {
        return seg.Funding_SegmentID;
      })
      this.disableApply = true;
      this.assignModalValues();
     
    }   
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  onlyNumberKey(event, type) {
    const pattern2 = type != 'ucmgId' ? /^[0-9]*[.]?[0-9]{0,2}?$/ : /^\d*$/;
    const inputChar = event.type != 'paste' ? String.fromCharCode(event.charCode) : event.clipboardData.getData('text');
    this.numberFormatters = {
      'optumTechLabour': this.addUcmgDataUpdated['optumTechLabour'],
      'advisoryService': this.addUcmgDataUpdated['advisoryService'],
      'bussinessLabour': this.addUcmgDataUpdated['bussinessLabour'],
      'hardwareSoftware': this.addUcmgDataUpdated['hardware_software'],
      'otherChargebacks': this.addUcmgDataUpdated['other_chargebacks'],
      'professionalFees': this.addUcmgDataUpdated['professional_fees'],
      'acap': this.addUcmgDataUpdated['acap'],
      'ucmgId': this.addUcmgDataUpdated['UCMG_ID']
    }
    if (!pattern2.test(inputChar)) {
      event.preventDefault();
    }
    if (inputChar === "." && this.numberFormatters[type].toString().includes(".")) {
      event.preventDefault();
    }
  }
  loadFundingSegment(){
    this.lobLoader = true;
    this.fundingSegmentSubscription = this.maintenanceService.getCapitalDemandList().subscribe((res: any) => {
      this.lobLoader = false;
      this.fundingSegmentList = res;
      this.fundingSegment = res.map(segment => segment.Funding_Segment);
      this.fundingSegment.sort((a, b) => a.localeCompare(b));
    }, (error) => {
      this.lobLoader = false;
    });
  }
  ngOnDestroy(): void {
    try {
      // Unsubscribe from fundingSegmentSubscription
      if (this.fundingSegmentSubscription) {
        this.fundingSegmentSubscription.unsubscribe();
      }
    } catch (error) {
      console.error('Error during cleanup:', error);
    }
  }
  searchFundingSegment(event){
    if (event.target.value.length == 0) {
      this.fundingSegment = this.fundingSegmentList.map(segment=>segment.Funding_Segment);
      return;
    }
    this.fundingSegment = this.fundingSegmentList.map(segment=>segment.Funding_Segment).filter(segment=>segment.toLowerCase().includes(event.target.value.toLowerCase()));
    this.fundingSegment = this.fundingSegment.length == 0 ? ['No results found'] : this.fundingSegment;
  }
  assignModalValues(){                      
    this.addUcmgDataUpdated.Funding_SegmentID = null;
    this.addUcmgDataUpdated.UCMG_ID = '';
    this.addUcmgDataUpdated.UCMG_Name = '';
    this.addUcmgDataUpdated.acap = null;
    this.addUcmgDataUpdated.advisoryService = null;
    this.addUcmgDataUpdated.bussinessLabour = null;
    this.addUcmgDataUpdated.hardware_software = null;
    this.addUcmgDataUpdated.optumTechLabour = null;
    this.addUcmgDataUpdated.other_chargebacks = null;
    this.addUcmgDataUpdated.professional_fees = null;
    this.addUcmgDataUpdated.year = null;
    this.addUcmgDataUpdated.investmentStatus = null;
  }
 

  change(){
  this.onInputChange();
  }

  onInputChange() {
    let acap = this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated.acap));
    this.allowNegative = acap >= 0 ? false : true;
  }
  disableApplyBtn() {
    let acap = this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated.acap));
    let invalidInputs = false;
    if (acap >= 0) {
      let negativeInputs = this.numberFieldsToCheck.some(
        field => this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated[field])) < 0
      );
      if (negativeInputs) {
        invalidInputs = true;
      }
    }
    let hasEmptyFields = Object.values(this.addUcmgDataUpdated).every(
      value => value !== null && value !== undefined && value.toString().trim() !== ''
    );
  
    return !hasEmptyFields || invalidInputs;
  }

  convertCommaSeparatedToNormal(value:any) {
    if(value == null ||value === '' || value === undefined|| value === '.'||value === '-'){
      return '';
    }
    else if (typeof (value) != 'number')
      return parseFloat(value.replace(/,/g, ''));
    else
      return value;
  }

   convertToDollarFormat(value) {
    if(value == null ||value === '' || value === undefined){
      return '';
    }
    value = value.toFixed();
    const rawValue = value.replace(/[^\d-]/g, '');
    const formatted = this.formatNumber(rawValue);
    return formatted;
  }

  private formatNumber(value: string): string {
    const number = Number(value) || '';
    return number.toLocaleString('en-US');
  }
 
  applyAddLeader() {
    
    this.lobLoader = true;
    const fundingSegmentId = this.findsegmentIdByName(this.addUcmgDataUpdated['Funding_SegmentID']);
    const payload = {
      Funding_SegmentID: fundingSegmentId,
      UCMG_ID: this.addUcmgDataUpdated.UCMG_ID,
      UCMG_Name: this.addUcmgDataUpdated.UCMG_Name,
      acap: this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated.acap)),
      optumTechLabour: this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated.optumTechLabour)),
      advisoryService: this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated.advisoryService)),
      bussinessLabour: this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated.bussinessLabour)),
      hardware_software: this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated.hardware_software)),
      other_chargebacks: this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated.other_chargebacks)),
      professional_fees: this.normalizeValue(this.convertCommaSeparatedToNormal(this.addUcmgDataUpdated.professional_fees)),
      fiscalYear: this.addUcmgDataUpdated.year.toString(),
      investmentStatus : this.addUcmgDataUpdated.investmentStatus.toUpperCase(),
      Portfolio_Manager: this.AddOwner.Portfolio_Manager,
      Ucmg_Owner: this.AddOwner.UCMG_Owner
    }
    this.maintenanceService.addNewUcmg(payload).subscribe({
      next: data => {
        if (data) {
          this.lobLoader = false;
          this.toaster.success("Successfully updated", '', { timeOut: 10000, positionClass: 'toast-top-center' });
          this.dataRefresh.emit(true);
          // this.assignModalValues();
          this.lobLoader = false;
        }
      },
      error: async error => {
        this.lobLoader = false;
        this.toaster.error(error.error.message, '', { timeOut: 10000, positionClass: 'toast-top-center' });
        if (error.error.status !== 400) {
          if (error.error.errors) {
            this.toaster.error(error.error.errors, '', { timeOut: 10000, positionClass: 'toast-top-center' });
          }
        }
      }
    });
  }
  findsegmentIdByName(name:string):number | undefined {
    const segment = this.fundingSegmentList.find(segment => segment.Funding_Segment === name);
    return segment? segment.Funding_SegmentID:undefined;
  }

  AddOwner = {
    'Portfolio_Manager': [],
    'UCMG_Owner': []
  };
  inputElement: any;
  disableEdit: boolean = true;
  userRole: any;
  LDAPusersPM: any = [];
  LDAPusersUCMG: any = [];
  private subject: Subject<string> = new Subject();
  destroy$: ReplaySubject<boolean> = new ReplaySubject(1);
  separatorKeysCodes: number[] = [ENTER];

  removePortfolioManagerAndUCMGOwner(user, role) {
    if (role === 'Portfolio_Manager') {
      const index = this.AddOwner.Portfolio_Manager.indexOf(user);
      if (index >= 0) {
        this.AddOwner.Portfolio_Manager.splice(index, 1);
      }
    }
    else {
      const index = this.AddOwner.UCMG_Owner.indexOf(user);
      if (index >= 0) {
        this.AddOwner.UCMG_Owner.splice(index, 1);
      }
    }
  }

  keyUpSearch(name, type) {
    const p: any = {}
    p['type'] = type;
    p['search'] = name.target.value;
    this.inputElement = name;
    if (name.target.value) {
      this.subject.next(p);
    }
    else if (!name.target.value && type === 'Portfolio_Manager') {
      this.LDAPusersPM = [];
    }
    else if (!name.target.value && type === 'UCMG_Owner') {
      this.LDAPusersUCMG = [];
    }
  }

  focusOnInput(type) {
    if (type === 'inputAddPortfolioManager') {
      this.inputAddPortfolioManager.nativeElement.focus();
    }
    else if (type === 'inputAddUCMGOwner') {
      this.inputAddUCMGOwner.nativeElement.focus();
    }
  }

  AddOwnerRole(event, role) {
    if (event.option.value.givenName !== '') {
      if (role === 'Portfolio_Manager') {
        this.userRole = role;
        this.AddOwner.Portfolio_Manager.push({
          givenName: event.option.value.givenName,
          sn: event.option.value.sn,
          mail: event.option.value.mail,
          displayName: event.option.value.displayName,
          employeeID: event.option.value.employeeID,
          msid: event.option.value.msid,
          middleName: event.option.value.sn
        });
      }
      else if (role === 'UCMG_Owner') {
        this.userRole = role;
        this.AddOwner.UCMG_Owner.push({
          givenName: event.option.value.givenName,
          sn: event.option.value.sn,
          mail: event.option.value.mail,
          displayName: event.option.value.displayName,
          employeeID: event.option.value.employeeID,
          msid: event.option.value.msid,
          middleName: event.option.value.sn
        }
      );
      }
    }
    if (this.inputElement) {
      this.inputElement.target.value = '';
      if(role === 'Portfolio_Manager'){
        this.LDAPusersPM = []
      } else if (role === 'UCMG_Owner'){
        this.LDAPusersUCMG = []
      }
    }
  }

  checkExistUser(user, type, actionType) {
    let tempVar = [];
    if (actionType === 'Add') {
      if (type === 'Portfolio_Manager') {
        tempVar = this.AddOwner.Portfolio_Manager;
      }
      else {
        tempVar = this.AddOwner.UCMG_Owner;
      }
    }
    let tempBool = false
    tempVar.forEach(archi => {
      if (user.msid === archi.msid) {
        tempBool = true;
      }
    });
    return tempBool;
  }

  handleSearch(searchObj) {
    console.log("searchObj", searchObj);
    let type = searchObj['type'];
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
        // Use the correct array based on type
        if (type === 'Portfolio_Manager') {
          this.LDAPusersPM = [];
          dataStream.forEach(element => {
            this.LDAPusersPM.push({
              givenName: element.givenName,
              sn: element.sn,
              mail: element.mail,
              displayName: element.displayName,
              employeeID: element.employeeID,
              msid: element.cn,
              middleName: element.middleName,
            });
          });
        } else if (type === 'UCMG_Owner') {
          this.LDAPusersUCMG = [];
          dataStream.forEach(element => {
            this.LDAPusersUCMG.push({
              givenName: element.givenName,
              sn: element.sn,
              mail: element.mail,
              displayName: element.displayName,
              employeeID: element.employeeID,
              msid: element.cn,
              middleName: element.middleName,
            });
          });
        }
      }, (error) => {
        console.error(error);
        const errorMessage = error?.error?.message ? error?.error?.message : 'Internal Server Error';
        this.toaster.error(errorMessage, '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      });
    } else {
      if (type === 'Portfolio_Manager') {
        this.LDAPusersPM = [];
      } else if (type === 'UCMG_Owner') {
        this.LDAPusersUCMG = [];
      }
      if (column) {
        column.options = [];
      }
    }
  }

  removeOwners(user, role) {
    if (role === 'Portfolio_Manager') {
      const index = this.AddOwner.Portfolio_Manager.indexOf(user);
      if (index >= 0) {
        this.AddOwner.Portfolio_Manager.splice(index, 1);
      }
    }
    else {
      const index = this.AddOwner.UCMG_Owner.indexOf(user);
      if (index >= 0) {
        this.AddOwner.UCMG_Owner.splice(index, 1);
      }
    }
  }

}

